import {Component, Inject, OnDestroy, OnInit, ViewEncapsulation} from "@angular/core";
import {LogCat, LogManager} from "../../common/index";
import {ActivatedRoute} from "@angular/router";
import {Subscription} from "rxjs";
import {LogService} from "../../common/log/services/log.service";
import {BrowserAttributes} from "../../common/browser/detect.browser";
import {WINDOW_LISTENER_TOKEN, WindowHostListenerService} from "../../common/window/window.host.listener.service";


// since we want to have the url and need to use postcss, which returns an output only css knows, we have a workaround
// this url is manually addressed from the index html!
// require("!!file-loader?name=roboto.custom.css!"+
// 	"!sass-loader?{\"sassOptions\":{\"includePaths\":[\"src/common/ui/styles\",\"src/app/shell/session\"]}}!" +
// 	"../../common/ui/styles/wrappers/roboto.fonts.wrapper.scss");
// require("!!file-loader?name=algotec.fonts.css!"+
// 	"!sass-loader?{\"sassOptions\":{\"includePaths\":[\"src/common/ui/styles\",\"src/app/shell/session\"]}}!" +
// 	"../../common/ui/styles/wrappers/fonts.wrapper.scss");

/* eslint-disable */

// require("!!file-loader?name=kendo.light.theme.css!"+
// 	"sass-loader?"+
// 	"{\"sassOptions\":{\"includePaths\":[\"src/common/ui/styles\",\"src/app/shell/session\"]},\"additionalData\":\"$includeLightTheme:true;$includeDarkTheme:true;$includeDynamicTheme:true;\"}"+
// 	"!../../common/ui/styles/kendo/kendo-themes/light-theme.scss");
// require("!!file-loader?name=kendo.dark.theme.css!"+
// 	"sass-loader?"+
// 	"{\"sassOptions\":{\"includePaths\":[\"src/common/ui/styles\",\"src/app/shell/session\"]},\"additionalData\":\"$includeLightTheme:true;$includeDarkTheme:true;$includeDynamicTheme:true;\"}"+
// 	"!../../common/ui/styles/kendo/kendo-themes/dark-theme.scss");
// require("!!file-loader?name=kendo.dynamic.theme.css!"+
// 	"sass-loader?"+
// 	"{\"sassOptions\":{\"includePaths\":[\"src/common/ui/styles\",\"src/app/shell/session\"]}, \"additionalData\":\"$includeLightTheme:true;$includeDarkTheme:true;$includeDynamicTheme:true;\"}"+
// 	"!../../common/ui/styles/kendo/kendo-themes/demo-theme.scss");


/* eslint-enable */


/*
	* App Component
	* Top Level Component
	*/
@Component({
	selector: 'cp-app',
	styleUrls: [
		//moved to angular.json
	],
	encapsulation: ViewEncapsulation.None, // since this component loads css files which are global for the application
	template: `	<cp-svg-icons-definitions></cp-svg-icons-definitions>
				<div [ngClass]="{'cp-app':true,'cp-is-ios':isIos, 'cp-is-mobile':isMobile}">
					<router-outlet></router-outlet>
					<!--<cp-rotate-screen-detector></cp-rotate-screen-detector>-->
				</div>`
})
export class VueRISAppComponent implements OnInit, OnDestroy {
	public sub: Subscription;
	public isIos: Boolean;
	public isMobile: Boolean;

	constructor(private route: ActivatedRoute,
				private browserDetect: BrowserAttributes,// bug #8409,private router:Router,
				private logService: LogService,
				@Inject(WINDOW_LISTENER_TOKEN ) private windowHostListenerService: WindowHostListenerService) {
	}

	ngOnInit() {
		this.isIos = this.browserDetect.isIos();
		this.isMobile = this.browserDetect.isMobile();
		this.windowHostListenerService.init();
		LogManager.debug(LogCat.User.Credentials, "VueRISApp started");
	}

	public ngOnDestroy() {
		if (this.sub) {
			this.sub.unsubscribe();
		}

		this.windowHostListenerService.destroy();
	}
}
